import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service'; 
import {HelperService} from '../../services/helper.service';
import {DownloadService} from "../../services/download.service"; 
import {DmsAccessService} from "../../services/dms-access.service";
import {TrainingService} from '../../services/training.service';
import {TosterMessageService} from '../../services/toster-message.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {IOption} from 'ng-select';

@Component({
  selector: 'app-question-bank-import-errors-modal',
  templateUrl: './question-bank-import-errors-modal.component.html',
  styleUrls: ['./question-bank-import-errors-modal.component.scss'],
  providers: [TrainingService, TosterMessageService, HelperService, DownloadService, DmsAccessService],
})
export class QuestionBankImportErrorsModalComponent implements OnInit {

  public masterData:any = {}; 
  public appliedFilterData: any = {};
  @ViewChild('swalModal') swalModal:any;
  @ViewChild('errorMessageHtml') errorMessageHtml:any;
  @ViewChild('f') form:any;
  public successMsg:string = '';
  public htmlErrorMessage:string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  uploadErrors: any = [];

  constructor(public bsModalRef:BsModalRef, 
              private tosterMessageService: TosterMessageService,
              private helperService:HelperService,
              private http: HttpClient,
              private downloadService: DownloadService,
              private spinner: NgxSpinnerService,
              private dmsAccessService: DmsAccessService,
              private modalService:BsModalService) {
  } 

  ngOnInit() {
  }

  showErrorHtml() {
    setTimeout(()=> {
      this.errorMessageHtml.show();
    }, 0)
  }

  showSuccessHtml() {
    setTimeout(()=> {
      this.swalModal.show();
    }, 0)
  } 


  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('upload_closed');
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('upload_closed');
  }

  showErrors(){
    //console.log('adf')
  }
}


// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-import-errors-modal/question-bank-import-errors-modal.component.ts